import { AfterContentInit, Directive, EventEmitter, Output, Input } from "@angular/core";

@Directive({
  selector: "[patchCloseCellEvent]",
  standalone: false,
})
export class BfxFindPatchCloseCellEvent implements AfterContentInit {
  @Output("onCloseCellEvent")
  public onCloseCellEvent: EventEmitter<any> = new EventEmitter();

  @Input("patchCloseCellEvent")
  public state: {
    dt: any;
    isAllowCloseEventFn: any;
  } | null = null;

  private _origCloseCell;

  public ngAfterContentInit(): void {
    if (this.state.dt && !this.state.dt["__bfx_patchCloseCellEvent"]) {
      this.state.dt["__bfx_patchCloseCellEvent"] = true;

      this._origCloseCell = this.state.dt.closeCell;

      this.state.dt.closeCell = this.closeCell.bind(this);
    }
  }

  public closeCell(skip: boolean = false): void {
    let closeCellArg = arguments;

    if (skip) {
      this._origCloseCell.call(this.state.dt);
    }

    if (this.state.isAllowCloseEventFn()) {
      if (this.state.dt.editingCell) {
        this.onCloseCellEvent.emit({
          cell: this.state.dt.editingCell,
        });

        this._origCloseCell.call(this.state.dt, closeCellArg);
      }
    }
  }
}
